import { ParticipantToProgrammeType, SessionType } from "../models/modelTypes";
import { sortSessions } from "./sorts";

export function getParticipantProgrammes(
    participantToProgramme: ParticipantToProgrammeType[] | undefined,
    programmeIdFilter?: number,
): ParticipantToProgrammeType[] {
    const programmes = participantToProgramme ?? [];
    if (programmeIdFilter === undefined) {
        return programmes;
    }
    return programmes.filter((ptp) => ptp.programmeId === programmeIdFilter);
}

export function countCompletedSessions(sessions: SessionType[] | undefined): number {
    return sessions?.filter((session) => session.state === "Complete").length ?? 0;
}

export function getNextSession(sessions: SessionType[] | undefined): SessionType | undefined {
    if (!sessions?.length) {
        return undefined;
    }

    const orderedSessions = [...sessions].sort(sortSessions);
    return orderedSessions.find((session) => session.state === "InProgress" || session.state === "NotStarted");
}

export function getProgrammeSummaryLabel(ptp: ParticipantToProgrammeType): string {
    const programme = ptp.Programme;
    const parts = [programme.isGroup ? "Group" : "1-2-1", programme.ageRange, programme.StoryCollection?.name].filter(
        (value) => value != null && value !== "",
    );

    return parts.join(" · ");
}

export function aggregateSessions(programmes: ParticipantToProgrammeType[]): SessionType[] {
    return programmes.flatMap((ptp) => ptp.Programme.Sessions ?? []);
}
